module.exports = __webpack_public_path__ + "static/media/video.54002a91.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video.mp4
// module id = 311
// module chunks = 0